<style>
.IndivShadow {
  box-shadow: 0 21px 24px rgba(0, 0, 0, 0.25), 0 -12px 30px rgba(0, 0, 0, 0.12),
    0 4px 6px rgba(0, 0, 0, 0.12), 0 12px 13px rgba(0, 0, 0, 0.17),
    0 -3px 5px rgba(0, 0, 0, 0.09) !important;
}
</style>
<template>
  <v-container
    style="max-width: 1500px;padding-top: 20px; overflow-x: scroll; white-space: nowrap;display: flex; justify-content: center;"
  >
    <v-row style="    width: -webkit-fill-available;">
      <div
        class="hidden-sm-and-down primary elevation-4"
        style="max-width: 640px; text-align: center; border-radius: 10px; width: 70%; margin: auto; margin-bottom: 20px; padding: 8px; height:120px"
      >
        <img
          src="../assets/Concord_Logo_Final.webp"
          style=" max-width: 15em;"
        />
        <h2 style=" color: white; font-size: 25px;  " id="headerText">
          A Community Built by Individuals
        </h2>
      </div>

      <div
        class="hidden-md-and-up primary"
        style=" text-align: center; border-radius: 10px; max-width: 640px; margin: auto; margin-bottom: 20px; padding: 8px;"
      >
        <img
          src="../assets/Concord_Logo_Final.webp"
          style=" max-width: 44vw;"
        />
        <h2 style=" color: white; font-size: 3.5vw;" id="headerText">
          A Community Built by Individuals
        </h2>
      </div>

      <v-dialog
        transition="dialog-bottom-transition"
        v-model="linkDialog"
        width="auto"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        style="border-radius: 10px; "
      >
        <v-card
          class="chatbackground"
          style="border-radius: 10px; text-align: center;"
        >
          <div
            class="titles "
            style="
              padding: 13px; border-radius: 10px 10px 0px 0px; padding-bottom: 0px;"
          >
            <div
              style="
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
            ></div>
          </div>
          <div
            class="titles hidden-sm-and-up"
            style="
              padding: 0px 13px 5px;   "
            v-touch="{
              down: () => (linkDialog = false),
            }"
          >
            <div
              style="
              background: white;
              height: 5px;
              width: 47%;
              margin: auto;
              border-radius: 10px;
          "
              class="elevation-3"
            ></div>
          </div>
          <v-card-title
            class="titles  "
            style="text-transform: capitalize;"
            v-touch="{
              down: () => (linkDialog = false),
            }"
          >
            <h4 style=" color:white;   margin: auto;font-size: 28px;">
              Sources for '{{ link_forumTitle.substring(0, 20) }}'
            </h4>
          </v-card-title>

          <!-- links -->
          <div style="padding-top: 5px;">
            <template v-for="link in link_links">
              <v-chip
                :key="link + link_forumTitle"
                class="ma-2 secondary elevation-4"
                style="height:25px;"
                text-color="primary"
                @click="open(link)"
                >{{ link.match(/([a-zA-z.]*)/)[1] }}</v-chip
              >
            </template>
          </div>

          <v-card-actions style="display: block;">
            <v-spacer></v-spacer>
            <v-btn
              class="primary elevation-4"
              text
              @click="resetLink()"
              style="border-radius:20px; color:white;     text-transform: none; font-weight: 600"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" bottom :timeout="2000" color="titles">
        Link Has Been Copied To Clipboard
      </v-snackbar>
      <template v-for="n in news" flat>
        <div
          v-bind="n"
          :key="n.title + n.forum_id + 'caro desktop'"
          style="display:inline"
          class="hidden-md-and-down"
        >
          <v-card
            class="elevation-0"
            style="max-width: 1200px;width: -webkit-fill-available;background: #00008b00; margin:auto"
          >
            <v-card
              class=" primary shadow"
              style=" border-radius: 10px; margin-bottom:25px; padding-bottom: 1px;     display: flex; justify-content: space-around;"
            >
              <div style="    width: 95%;">
                <v-carousel
                  lazy
                  class="elevation-0 carousel-concormobile"
                  style=" padding: 10px;"
                  hide-delimiters
                  height="auto"
                  :cycle="false"
                  :continuous="false"
                  v-model="caro['desktop' + n.forum_id]"
                >
                  <v-carousel-item
                    flat
                    v-bind="n"
                    v-for="(item, i) in n.items"
                    :alt="n.title"
                    :key="i + n.title + n.forum_id + 'caro mobile'"
                    :src="item"
                    style="max-width: 700px; border-radius: 10px; border: 1px solid white"
                  >
                    <div
                      v-if="i == 0 && !seen"
                      id="desktopTutorial"
                      class="titles"
                      style="float: left;
                    position: relative;
                    z-index: 1000;
                    padding: 5px;
                    color: white;
                    font-weight: bold;
                    opacity: .8; font-size: 3vh;
                    display: flex;
                    width: 80%;
                    justify-content: center;
                    align-items: center;
                    left: 50%;
                    top: 51%;
                    border-radius: 10px;
                    -webkit-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);"
                    >
                      Tap&nbsp;<v-icon
                        color="white"
                        style="font-size: 3.5vh; margin-left:3px; background: #ffffff30; border-radius: 50px;"
                        >chevron_right</v-icon
                      >&nbsp;To See More
                    </div>
                    <v-btn
                      class="carousel-concord-btn primary  "
                      fab
                      dark
                      small
                      style="color: white;opacity:.8; float:right"
                    >
                      <span style="font-size:11px"
                        >{{ i + 1 }}/{{ n.items.length }}</span
                      >
                    </v-btn>
                  </v-carousel-item>
                </v-carousel>
                <div
                  style="    display: flex; justify-content: center; margin-top: -10px;"
                >
                  <div
                    v-for="i in n.items.length"
                    :key="i + 'desktop slides' + n.forum_id"
                  >
                    <v-icon
                      v-if="i - 1 == caro['desktop' + n.forum_id]"
                      color="secondary"
                      style="font-size: 10px; margin-left:3px;"
                      >adjust</v-icon
                    >
                    <v-icon
                      v-else
                      color="white"
                      style="font-size: 10px; margin-left:3px;"
                      @click="caro['desktop' + n.forum_id] = i - 1"
                      >adjust</v-icon
                    >
                  </div>
                </div>

                <div
                  v-show="n.tags.length > 0"
                  style="overflow-wrap: anywhere; white-space: break-spaces; margin:5px; text-align-last: center;"
                >
                  <template v-for="(tag, i) in n.tags">
                    <v-chip
                      v-if="i != n.tags.length - 1"
                      :key="tag + n.title + n.forum_id + 'tags'"
                      color="titles"
                      class="ma-2 elevation-4"
                      text-color="white"
                      >{{ tag }}</v-chip
                    >
                    <v-chip
                      v-else
                      :key="tag + n.title + n.forum_id + 'tags'"
                      color="secondary"
                      class="ma-2 elevation-4"
                      text-color="titles"
                      >{{ tag }}</v-chip
                    >
                  </template>
                  <v-list
                    style=" padding-top:0; padding-bottom: 0; background-color:#6aaaff05"
                  >
                    <div
                      style="overflow-wrap: anywhere; white-space: break-spaces;"
                    >
                      <v-btn
                        v-show="n.links.length > 0"
                        @click="setLink(n.title, n.links, n.tags)"
                        class="secondary elevation-4 titles--text"
                        flat
                        fab
                        small
                      >
                        <v-icon dark style="font-size:20px; ">link</v-icon>
                      </v-btn>
                      <v-btn
                        outline
                        color="secondary"
                        text-color="secondary"
                        flat
                        class="upvote elevation-4"
                        style="border-radius: 20px;  height:40px; min-width:5px; color:white; padding: 10px;     font-weight: 600;"
                      >
                        <v-icon dark style="font-size:20px; "
                          >star_border</v-icon
                        >
                        &nbsp; {{ n.count }}
                      </v-btn>

                      <v-btn
                        flat
                        class="danger elevation-4 white--text"
                        fab
                        small
                        style="color:white; "
                        @click="shareStory(n, n.tags)"
                      >
                        <v-icon dark style="font-size:20px; ">ios_share</v-icon>
                      </v-btn>
                    </div>
                  </v-list>
                </div>
              </div>
              <div style="    width: 95%;">
                <v-layout
                  row
                  style="padding: 0% 2% 3%; text-align:center; display: block; margin-top: 10px;"
                >
                  <v-flex
                    style="padding-bottom: 10px; margin-left: 6px; margin-right: 6px;"
                  >
                    <v-select
                      id="desktopQTC"
                      :items="n.QTC"
                      v-model="n.chosen"
                      cache-items
                      flat
                      hide-no-data
                      hide-details
                      label="Respond to or Filter by a Question to Consider"
                      solo
                      dense
                      clearable
                      style="    white-space: pre-wrap;"
                    ></v-select>
                  </v-flex>
                  <div
                    class=" elevation-4"
                    style="display: flex; margin-top: 5px; margin-left: 6px; margin-right: 6px; border-radius: 10px;  background: white;"
                  >
                    <v-textarea
                      maxlength="1000"
                      style="padding:10px; border-radius:20px;"
                      counter="1000"
                      clearable
                      no-resize
                      :id="n.forum_id"
                      rows="2"
                      shaped
                      v-model="n.input"
                      label="Discuss..."
                      disabled
                    >
                    </v-textarea>
                    <div
                      class="primary"
                      style="display:grid; border-radius: 0px 10px 10px 0px; border: 1px solid white !important; border-left: 0;"
                    >
                      <v-btn
                        outline
                        fab
                        dark
                        small
                        color="secondary"
                        class="elevation-3"
                        disabled
                      >
                        <v-icon dark style="font-size:20px; color: #F1CE3E"
                          >add_link</v-icon
                        >
                      </v-btn>

                      <v-btn fab dark small disabled class="titles elevation-3">
                        <v-icon dark style="font-size:20px;  border-radius:50px"
                          >send</v-icon
                        >
                      </v-btn>
                    </div>
                  </div>
                </v-layout>

                <div
                  class="scroll-y chatbackground elevation-4"
                  id="scroll-target"
                  style="width: auto; height: 510px; border-radius: 10px; margin:12px;     margin-top: 0px;"
                >
                  <v-list
                    v-if="n.sortedMessages.length > 0"
                    id="scroll-container"
                    class="chatbackground"
                    two-line
                    v-scroll:#scroll-target
                    style="padding-top: 0px; padding-bottom: 0px;"
                  >
                    <template
                      v-for="item in n.sortedMessages"
                      pa-1
                      style="min-height:72px; "
                    >
                      <div
                        :key="
                          item.senderID +
                            n.title +
                            n.forum_id +
                            item.messageID +
                            ' desktop'
                        "
                        v-show="
                          indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC
                        "
                        class="elevation-1 "
                        style="border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; background:white;"
                      >
                        <div>
                          <p
                            pa-2
                            style="font-weight: bold; font-size:16px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                            class="text-wrap"
                          >
                            {{ item.sender }}
                          </p>
                          <p
                            v-show="!item.deleted"
                            pa-2
                            style="font-weight: bold;font-size:12px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                            class="text-wrap"
                          >
                            {{ item.time }}
                          </p>
                        </div>

                        <p
                          v-show="!item.deleted"
                          class="text-wrap"
                          style="font-size: 16px;margin-bottom: 0px;overflow-wrap: break-word;padding-right: 10px; display:block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                          pa-1
                        >
                          {{ item.message }}
                        </p>
                        <div
                          style="white-space: pre-wrap; display: flex; margin: 6px; justify-content: flex-end; margin-right: -14px;"
                        >
                          <div
                            style="width: min-content;border-radius: 20px;display: flex;text-align: center;"
                            class="primary elevation-3"
                          >
                            <v-btn
                              v-show="item.links.length > 0"
                              @click="setLink(item.message, item.links, n.tags)"
                              class="secondary elevation-4 titles--text"
                              flat
                              fab
                              small
                            >
                              <v-icon dark style="font-size:20px; "
                                >link</v-icon
                              >
                            </v-btn>

                            <v-btn
                              outline
                              color="secondary"
                              text-color="secondary"
                              flat
                              class="upvote elevation-4"
                              style="border-radius: 20px;  height:40px; min-width:5px; color:white;  padding: 10px;     font-weight: 600;"
                            >
                              <v-icon dark style="font-size:20px; "
                                >star_border</v-icon
                              >
                              &nbsp; {{ item.count }}
                            </v-btn>

                            <v-btn
                              class="titles elevation-4"
                              v-show="item.threads"
                              @click="(item.threads = false), updateView()"
                              flat
                              pa-1
                              style="border-radius: 20px;min-width: 5px; padding: 10px;  height:40px;margin-bottom: 6px;  color:white;  font-weight: 600;"
                            >
                              <v-icon dark small style="font-size:22px; "
                                >speaker_notes</v-icon
                              >
                              &nbsp; {{ item.thread.length }}
                            </v-btn>
                            <v-btn
                              class="titles elevation-4"
                              v-show="!item.threads"
                              @click="(item.threads = true), updateView()"
                              flat
                              pa-1
                              style="border-radius: 20px; min-width: 5px; padding: 10px; height:40px;margin-bottom: 6px; color:white;  font-weight: 600;"
                            >
                              <v-icon dark small style="font-size:22px; "
                                >reply</v-icon
                              >
                              &nbsp; {{ item.thread.length }}
                            </v-btn>
                          </div>
                        </div>
                      </div>

                      <v-layout
                        v-show="
                          item.threads &&
                            (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                        "
                        :key="
                          item +
                            n.forum_id +
                            item.messageID +
                            'threads  desktop'
                        "
                        class="elevation-1 "
                        row
                        style=" border-radius: 20px;margin: 7px;margin-left: 45px; background:white"
                      >
                        <v-textarea
                          maxlength="1000"
                          clearable
                          no-resize
                          counter="1000"
                          style="padding:10px;  color:white; margin-left:20px"
                          rows="2"
                          :id="item.messageID"
                          label="Respond..."
                          v-model="item.input"
                          disabled
                        >
                        </v-textarea>
                        <div
                          class="primary"
                          style="display:grid; border-radius: 0px 20px 20px 0px; border: 1px solid white !important; border-left: 0px;"
                        >
                          <v-btn
                            outline
                            fab
                            dark
                            small
                            color="secondary"
                            class="elevation-3"
                            disabled
                          >
                            <v-icon dark style="font-size:20px; color: #F1CE3E"
                              >add_link</v-icon
                            >
                          </v-btn>
                          <v-btn fab dark small disabled class="titles">
                            <v-icon
                              dark
                              style="font-size:20px;border-radius:50px"
                              >send</v-icon
                            >
                          </v-btn>
                        </div>
                      </v-layout>

                      <template
                        v-for="threadItem in item.thread"
                        pa-1
                        style="  padding-left: 10px"
                      >
                        <div
                          :key="
                            threadItem.senderID +
                              n.title +
                              n.forum_id +
                              ' desktop'
                          "
                          v-show="
                            item.threads &&
                              (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                          "
                          class="elevation-1 "
                          style="background:white;border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; margin-left: 45px; "
                        >
                          <v-card v-show="item.threads" flat pa-1>
                            <div>
                              <p
                                pa-2
                                style="font-weight: bold; font-size:16px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                                class="text-wrap"
                              >
                                {{ threadItem.sender }}
                              </p>
                              <p
                                pa-2
                                style="font-weight: bold; font-size:12px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                                class="text-wrap"
                              >
                                {{ threadItem.time }}
                              </p>
                              <p
                                class="text-wrap"
                                style="font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px;display: block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                                pa-1
                              >
                                {{ threadItem.message }}
                              </p>
                            </div>
                            <div
                              style="white-space: pre-wrap;display: flex;margin: 6px; justify-content: flex-end; margin-right: -14px;"
                            >
                              <div
                                class="primary elevation-3"
                                style="    width: min-content;border-radius: 20px;display: flex;text-align: center;"
                              >
                                <v-btn
                                  v-show="threadItem.links.length > 0"
                                  flat
                                  class="secondary elevation-4 titles--text"
                                  fab
                                  small
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >link</v-icon
                                  >
                                </v-btn>

                                <v-btn
                                  outline
                                  color="secondary"
                                  text-color="secondary"
                                  class="upvote elevation-4"
                                  flat
                                  style="border-radius: 20px;  height:40px; min-width:5px;  padding: 10px; color: white;     font-weight: 600;"
                                >
                                  <v-icon dark style="font-size:20px; "
                                    >star_border</v-icon
                                  >
                                  &nbsp; &nbsp; {{ threadItem.count }}
                                </v-btn>
                              </div>
                            </div>
                          </v-card>
                        </div>
                      </template>
                    </template>
                  </v-list>
                  <v-card
                    v-else
                    style="text-align: center; display:inline; background:white;"
                  >
                    <h3
                      style="padding: 25px; background:white; margin: 10px; border-radius: 15px;"
                    >
                      Start the Discussion
                    </h3>
                  </v-card>
                </div>
              </div>
            </v-card>
          </v-card>
        </div>

        <!-- mobile -->

        <div
          :key="n.forum_id + 'forum'"
          style="display:inline"
          class="hidden-lg-and-up"
        >
          <v-card
            class="elevation-0"
            style="max-width: 640px;width: -webkit-fill-available;background: #00008b00; margin:auto"
          >
            <v-card
              class=" primary shadow"
              style=" border-radius: 10px; margin-bottom:25px; padding-bottom: 1px; "
            >
              <div
                style="display: flex; justify-content: space-between; color: white; align-items: center; padding-left: 10px; font-weight: 600; padding-top: 5px; padding-bottom: 5px;"
              >
                {{ n.time }}
              </div>
              <v-carousel
                lazy
                class="elevation-0 carousel-concormobile"
                height="100%"
                style=" padding: 7px; padding-top: 0px;"
                hide-delimiters
                :cycle="false"
                :continuous="false"
                v-model="caro['mobile' + n.forum_id]"
              >
                <v-carousel-item
                  flat
                  v-bind="n"
                  v-for="(item, i) in n.items"
                  :alt="n.title"
                  :key="i + n.title + n.forum_id + 'caro'"
                  :src="item"
                  height="100%"
                  style="max-width: 700px; border-radius: 10px; border: 1px solid white"
                >
                  <div
                    v-if="i == 0 && !seen"
                    id="desktopTutorial"
                    class="titles"
                    style="float: left;
                    position: relative;
                    z-index: 1000;
                    padding: 5px;
                    color: white;
                    font-weight: bold;
                    opacity: .8; font-size: 2vh;
                    display: flex;
                    width: 80%;
                    justify-content: center;
                    align-items: center;
                    left: 50%;
                    top: 51%;
                    border-radius: 10px;
                    -webkit-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);"
                  >
                    <v-icon
                      color="white"
                      style="font-size: 2.5vw; margin-left:3px; background: #ffffff30; border-radius: 50px;"
                      >chevron_right</v-icon
                    >&nbsp; Tap or Swipe To See More &nbsp;
                    <v-icon
                      color="white"
                      style="font-size: 2.5vw; margin-left:3px; background: #ffffff30; border-radius: 50px;"
                      >chevron_right</v-icon
                    >
                  </div>
                  <v-btn
                    class="carousel-concord-btn primary  "
                    fab
                    dark
                    small
                    style="color: white;opacity:.8; float:right"
                  >
                    <span style="font-size:11px"
                      >{{ i + 1 }}/{{ n.items.length }}</span
                    >
                  </v-btn>
                </v-carousel-item>
              </v-carousel>
              <div
                style="    display: flex; justify-content: center; margin-top: -10px;"
              >
                <div
                  v-for="i in n.items.length"
                  :key="i + 'mobile slides' + n.forum_id"
                >
                  <v-icon
                    v-if="i - 1 == caro['mobile' + n.forum_id]"
                    color="secondary"
                    style="font-size: 10px; margin-left:3px;"
                    >adjust</v-icon
                  >
                  <v-icon
                    v-else
                    color="white"
                    style="font-size: 10px; margin-left:3px;"
                    @click="caro['mobile' + n.forum_id] = i - 1"
                    >adjust</v-icon
                  >
                </div>
              </div>

              <v-layout
                row
                style="padding: 0% 2% 3%; text-align:center;display: block;"
              >
                <v-list
                  style=" padding-top:0; padding-bottom: 0; background-color:#6aaaff05"
                >
                  <div
                    style="overflow-wrap: anywhere; white-space: break-spaces; margin:5px"
                    v-show="n.tags.length > 0"
                  >
                    <template v-for="(tag, i) in n.tags">
                      <v-chip
                        v-if="i != n.tags.length - 1"
                        :key="tag + n.title + n.forum_id + 'tags'"
                        color="titles"
                        class="ma-2 elevation-4"
                        text-color="white"
                        >{{ tag }}</v-chip
                      >
                      <v-chip
                        v-else
                        :key="tag + n.title + n.forum_id + 'tags'"
                        color="secondary"
                        class="ma-2 elevation-4"
                        text-color="titles"
                        >{{ tag }}</v-chip
                      >
                    </template>
                  </div>

                  <div
                    style="overflow-wrap: anywhere; white-space: break-spaces;"
                  >
                    <v-btn
                      v-show="n.links.length > 0"
                      @click="setLink(n.title, n.links, n.tags)"
                      class="secondary elevation-4 titles--text"
                      flat
                      fab
                      small
                    >
                      <v-icon dark style="font-size:20px; ">link</v-icon>
                    </v-btn>
                    <v-btn
                      outline
                      color="secondary"
                      text-color="secondary"
                      flat
                      class="upvote elevation-4"
                      style="border-radius: 20px;  height:40px; min-width:5px; color:white; padding: 10px;     font-weight: 600;"
                    >
                      <v-icon dark style="font-size:20px; ">star_border</v-icon>
                      &nbsp; {{ n.count }}
                    </v-btn>

                    <v-btn
                      class="titles elevation-4"
                      v-show="n.chat"
                      @click="(n.chat = false), updateView()"
                      flat
                      pa-1
                      style="border-radius: 20px;min-width: 5px;padding:10px;height:40px;margin-bottom: 6px;  color:white;  font-weight: 600;"
                    >
                      <v-icon dark small style="font-size:22px; "
                        >speaker_notes</v-icon
                      >
                      &nbsp; {{ n.sortedMessages.length }}
                    </v-btn>
                    <v-btn
                      class="titles elevation-4"
                      v-show="!n.chat"
                      @click="(n.chat = true), updateView()"
                      flat
                      pa-1
                      style="border-radius: 20px; min-width: 5px;padding:10px;height:40px;margin-bottom: 6px; color:white;  font-weight: 600;"
                    >
                      <v-icon dark small style="font-size:22px; "
                        >speaker_notes_off</v-icon
                      >
                      &nbsp; {{ n.sortedMessages.length }}
                    </v-btn>
                    <v-btn
                      flat
                      class="danger elevation-4 white--text"
                      fab
                      small
                      @click="shareStory(n)"
                    >
                      <v-icon dark style="font-size:20px; ">ios_share</v-icon>
                    </v-btn>
                  </div>
                </v-list>

                 <v-flex
                  style="padding-bottom: 5px; padding-top: 5px; margin-left: 6px; margin-right: 6px;"
                >
                  <v-select
                    id="desktopQTC"
                    :items="n.QTC"
                    v-model="n.chosen"
                    cache-items
                    flat
                    hide-no-data
                    hide-details
                    label="Respond to or Filter by a Question to Consider"
                    solo
                    dense
                    clearable
                    style="    white-space: pre-wrap;"
                    @change="n.chat = true"
                  ></v-select>
                </v-flex>

                <div
                  class=" elevation-4"
                  style="display: flex; margin-top: 10px; margin-left: 6px; margin-right: 6px; border-radius: 10px;  background: white;"
                >
                  <v-textarea
                    maxlength="1000"
                    style="padding:10px; border-radius:20px;"
                    counter="1000"
                    clearable
                    no-resize
                    :id="n.forum_id"
                    rows="2"
                    shaped
                    disabled
                    v-model="n.input"
                    label="Discuss..."
                  >
                  </v-textarea>
                  <div
                    class="primary"
                    style="display:grid; border-radius: 0px 10px 10px 0px; border: 1px solid white !important; border-left: 0;"
                  >
                    <v-btn
                      outline
                      fab
                      dark
                      small
                      disabled
                      color="secondary"
                      class="elevation-3"
                    >
                      <v-icon dark style="font-size:20px; color: #F1CE3E"
                        >add_link</v-icon
                      >
                    </v-btn>

                    <v-btn fab dark small disabled class="titles elevation-3">
                      <v-icon dark style="font-size:20px; border-radius:50px"
                        >send</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
              </v-layout>

              <div
                class="scroll-y chatbackground elevation-4"
                v-show="n.chat"
                id="scroll-target"
                style="width: auto;max-height: 560px; border-radius: 10px; margin:12px;     margin-top: 0px;"
              >
                <v-list
                  v-if="n.sortedMessages.length > 0"
                  id="scroll-container"
                  class="chatbackground"
                  two-line
                  v-scroll:#scroll-target
                  style="padding-top: 0px; padding-bottom: 0px;"
                >
                  <template
                    v-for="item in n.sortedMessages"
                    pa-1
                    style="min-height:72px; "
                  >
                    <div
                     :key="
                        item.senderID + n.title + n.forum_id + item.messageID
                      "
                      class="elevation-1 "
                      style="border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; background:white;"
                      v-show="indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC"
                    >
                      <div>
                        <p
                         
                          pa-2
                          style="font-weight: bold; font-size:16px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                          class="text-wrap"
                        >
                          {{ item.sender }}
                        </p>
                        <p
                          
                          v-show="!item.deleted"
                          pa-2
                          style="font-weight: bold;font-size:12px; padding-top: 2px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                          class="text-wrap"
                        >
                          {{ item.time }}
                        </p>
                      </div>

                      <p
                        v-show="!item.deleted"
                        class="text-wrap"
                        style="font-size: 16px;margin-bottom: 0px;overflow-wrap: break-word;padding-right: 10px; display:block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                        
                        pa-1
                      >
                        {{ item.message }}
                      </p>
                      <div
                        style="    white-space: pre-wrap; display: flex; margin: 6px; justify-content: flex-end; margin-right: -14px;"
                      >
                        <div
                          style="    width: min-content;border-radius: 20px;display: flex;text-align: center;"
                          class="primary elevation-3"
                        >
                          <v-btn
                            v-show="item.links.length > 0"
                            @click="setLink(item.message, item.links, n.tags)"
                            class="secondary elevation-4 titles--text"
                            flat
                            fab
                            small
                          >
                            <v-icon dark style="font-size:20px; ">link</v-icon>
                          </v-btn>

                          <v-btn
                            outline
                            color="secondary"
                            text-color="secondary"
                            flat
                            class="upvote elevation-4"
                            style="border-radius: 20px;  height:40px; min-width:5px; color:white;  padding: 10px;     font-weight: 600;"
                          >
                            <v-icon dark style="font-size:20px; "
                              >star_border</v-icon
                            >
                            &nbsp; {{ item.count }}
                          </v-btn>

                          <v-btn
                            class="titles elevation-4"
                            v-show="item.threads"
                            @click="(item.threads = false), updateView()"
                            flat
                            pa-1
                            style="border-radius: 20px;min-width: 5px; padding: 10px;  height:40px;margin-bottom: 6px;  color:white; font-weight: 600;"
                          >
                            <v-icon dark small style="font-size:22px; "
                              >speaker_notes</v-icon
                            >
                            &nbsp; {{ item.thread.length }}
                          </v-btn>
                          <v-btn
                            class="titles elevation-4"
                            v-show="!item.threads"
                            @click="(item.threads = true), updateView()"
                            flat
                            pa-1
                            style="border-radius: 20px; min-width: 5px; padding: 10px; height:40px;margin-bottom: 6px; color:white; font-weight: 600;"
                          >
                            <v-icon dark small style="font-size:22px; "
                              >reply</v-icon
                            >
                            &nbsp; {{ item.thread.length }}
                          </v-btn>
                        </div>
                      </div>
                    </div>

                    <v-layout
                      v-show="
                        item.threads &&
                          (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                      "
                      :key="item + n.forum_id + item.messageID + 'threads'"
                      class="elevation-1 "
                      row
                      style=" border-radius: 20px;margin: 7px;margin-left: 45px; background:white"
                    >
                      <v-textarea
                        maxlength="1000"
                        clearable
                        no-resize
                        counter="1000"
                        style="padding:10px;  color:white; margin-left:20px"
                        rows="2"
                        :id="item.messageID"
                        label="Respond..."
                        v-model="item.input"
                        disabled
                      >
                      </v-textarea>
                      <div
                        class="primary"
                        style="display:grid; border-radius: 0px 20px 20px 0px; border: 1px solid white !important; border-left: 0px;"
                      >
                        <v-btn
                          outline
                          fab
                          dark
                          small
                          color="secondary"
                          class="elevation-3"
                          disabled
                        >
                          <v-icon dark style="font-size:20px; color: #F1CE3E"
                            >add_link</v-icon
                          >
                        </v-btn>

                        <v-btn fab dark small class="titles" disabled>
                          <v-icon dark style="font-size:20px;border-radius:50px"
                            >send</v-icon
                          >
                        </v-btn>
                      </div>
                    </v-layout>

                    <template
                      v-for="threadItem in item.thread"
                      pa-1
                      style="  padding-left: 10px"
                    >
                      <div
                        :key="threadItem.senderID + n.title + n.forum_id"
                        v-show="
                          item.threads &&
                            (indexOfQTC(n) == -1 || indexOfQTC(n) == item.QTC)
                        "
                        class="elevation-1 "
                        style="background:white;border-radius: 20px;  padding: 20px; padding-bottom:2px; margin:7px; margin-left: 45px; "
                      >
                        <v-card
                          
                          v-show="item.threads"
                          flat
                          pa-1
                        >
                          <div>
                            <p
                              pa-2
                              style="font-weight: bold; font-size:16px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                              class="text-wrap"
                            >
                              {{ threadItem.sender }}
                            </p>
                            <p
                              pa-2
                              style="font-weight: bold; font-size:12px; padding-top: 2px;padding-left: 10px;margin-bottom: 0px;  text-transform: capitalize; clear:both;"
                              class="text-wrap"
                            >
                              {{ threadItem.time }}
                            </p>
                            <p
                              class="text-wrap"
                              style="font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px;display: block;white-space: normal;word-wrap: break-word;width: auto; clear:right"
                              pa-1
                            >
                              {{ threadItem.message }}
                            </p>
                          </div>
                          <div
                            style="white-space: pre-wrap;display: flex;margin: 6px; justify-content: flex-end; margin-right: -14px;"
                          >
                            <div
                              class="primary elevation-3"
                              style="    width: min-content;border-radius: 20px;display: flex;text-align: center;"
                            >
                              <v-btn
                                v-show="threadItem.links.length > 0"
                                @click="
                                  setLink(
                                    threadItem.message,
                                    threadItem.links,
                                    n.tags
                                  )
                                "
                                flat
                                class="secondary elevation-4 titles--text"
                                fab
                                small
                              >
                                <v-icon dark style="font-size:20px; "
                                  >link</v-icon
                                >
                              </v-btn>

                              <v-btn
                                outline
                                color="secondary"
                                text-color="secondary"
                                class="upvote elevation-4"
                                flat
                                style="border-radius: 20px;  height:40px; min-width:5px;  padding: 10px; color: white;     font-weight: 600;"
                              >
                                <v-icon dark style="font-size:20px; "
                                  >star_border</v-icon
                                >
                                &nbsp; &nbsp; {{ threadItem.count }}
                              </v-btn>
                            </div>
                          </div>
                        </v-card>
                      </div>
                    </template>
                  </template>
                </v-list>
                <v-card
                  v-else
                  style="text-align: center; display:inline; background:white;"
                >
                  <h3 style="padding: 25px; background:white;">
                    Start the Discussion
                  </h3>
                </v-card>
              </div>
            </v-card>
          </v-card>
        </div>
      </template>
      <div v-show="loading === true">
        <div class="fingerprint-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase";
import "firebase/firestore";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: true,
      editing: false,
      message: "",
      image: null,
      imageExt: "",
      show: false,
      news: [],
      on: true,
      hover: false,
      linkDialog: false,
      link_forumTitle: "",
      link_links: [],
      link_tags: [],
      caro: {},
      savedCaros: {},
      snackbar: false,
      seen: false,
    };
  },
  watch: {
    user(auth) {
      if (auth) {
        this.$router.push(`/news/${this.$route.params.id}`);
      }
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted: async function() {
    var self = this;
    setTimeout(function() {
      const date2 = new Date();
      firebase
        .firestore()
        .collection("concordposts")
        .doc(self.$route.params.id)
        .get()
        .then((doc) => {
          if (doc.data()) {
            self.concordTab = true;
            self.news.push(doc.data());

            self.news.forEach(async function(value) {
              value.sortedMessages.sort(function(a, b) {
                if (b.count == a.count) {
                  return b.thread.length - a.thread.length;
                }
                return b.count - a.count;
              });
              value.sortedMessages.forEach((value2) => {
                value2.thread.sort(function(a, b) {
                  return b.count - a.count;
                });
                value2.threads = false;
              });

              value.time = self.formatTime(date2, value);
              value.sortedMessages.forEach((value2) => {
                value2.time = self.formatTime(date2, value2);

                value2.thread.forEach((value3) => {
                  value3.time = self.formatTime(date2, value3);
                });
              });

              if (value.items.length == 0) {
                await firebase
                  .storage()
                  .ref(value.itemPath)
                  .listAll()
                  .then(function(res) {
                    var arr = [];

                    for (var i = 0; i < res.items.length; i++) {
                      arr.push[""];
                    }

                    res.items.forEach(function(itemRef) {
                      var starsRef = firebase.storage().ref(itemRef.fullPath);
                      // Get the download URL
                      starsRef.getDownloadURL().then(function(url) {
                        const index = parseInt(itemRef.name);
                        value.items[index] = url;
                        self.$forceUpdate();
                      });
                    });
                  });
              }
            });
          }
        });

      self.loading = false;
    }, 2000);
    setTimeout(function() {
      self.seen = true;
    }, 11000);
  },
  methods: {
    setLink(forumTitle, links, tags) {
      this.linkDialog = true;
      this.link_forumTitle = forumTitle;
      this.link_links = links;
      this.link_tags = tags;
    },
    formatTime(date2, value) {
      const diffTimes = date2.getTime() - value.time;
      const diffDayss = Math.floor(diffTimes / (1000 * 60 * 60 * 24));
      if (diffDayss < 1) {
        var diff = (date2.getTime() - value.time) / 1000;
        diff /= 60 * 60;
        if (diff < 1) {
          var minutes = Math.floor(diff * 60);
          if (Math.abs(Math.round(minutes)) == 1) {
            value.time = Math.abs(Math.round(minutes)) + " minute ago";
          } else {
            value.time = Math.abs(Math.round(minutes)) + " minutes ago";
          }
        } else {
          if (Math.abs(Math.round(diff)) == 1) {
            value.time = 1 + " hour ago";
          } else {
            value.time = Math.abs(Math.round(diff)) + " hours ago";
          }
        }
      } else {
        if (diffDayss == 1) {
          value.time = diffDayss + " day ago";
        } else if (diffDayss >= 7) {
          value.time = new Date(value.time).toDateString();
          value.time =
            value.time.substring(3, 10) + "," + value.time.substring(10);
        } else {
          value.time = diffDayss + " days ago";
        }
      }
      return value.time;
    },
    shareStory(story) {
      if (navigator.share) {
        navigator
          .share({
            title: story.title,
            text: story.title,
            url: `https://concordreport.com/share/${story.forum_id}`,
          })
          .then(() => {
            // eslint-disable-next-line no-console
            console.log("Successful share");
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log("Error sharing", error);
          });
      } else {
        navigator.clipboard.writeText(
          `https://concordreport.com/share/${story.forum_id}`
        );
        this.snackbar = true;
      }
    },
    resetLink() {
      this.linkDialog = false;
      this.link_forumTitle = "";
      this.link_links = [];
      this.link_tags = [];
    },
    open(link) {
      window.open("http://" + link, "_blank");
    },
    updateView() {
      this.$forceUpdate();
    },
    indexOfQTC(n) {
      if (n.QTC) {
        return n.QTC.indexOf(n.chosen);
      } else {
        return -1;
      }
    },
  },
};
</script>
